<script setup>
import { Eye, EyeOff } from "lucide-vue-next";
import { defineProps, defineEmits, computed, ref, onMounted } from "vue";

const props = defineProps({
  modelValue: [String, Number],
  label: String,
  placeholder: String,
  disabled: Boolean,
  maxLength: Number,
  type: {
    type: String,
    default: "text",
  },
  error: String,
});
const showPassword = ref(false);

const emit = defineEmits(["update:modelValue"]);

const updateValue = (event) => {
  emit("update:modelValue", event.target.value);
};

// decide o tipo do input
const inputType = computed(() =>
  props.type === "password"
    ? showPassword.value
      ? "text"
      : "password"
    : props.type
);
</script>

<template>
  <div class="mb-2">
    <label
      class="text-[14px] text-gray-900 block mb-2 font-palanquin text-md font-medium"
    >
      {{ label }}
    </label>
    <div
      class="relative bg-gray-50 border text-gray-900 text-sm rounded-md block w-full"
    >
      <input
        :type="inputType"
        :placeholder="placeholder"
        class="w-full bg-transparent outline-none focus:ring-green-300 focus:border-green-300 p-2.5 pr-10"
        :value="modelValue"
        @input="updateValue"
        :disabled="disabled"
        :maxLength="maxLength"
      />

      <!-- toggle de senha -->
      <button
        v-if="props.type === 'password'"
        type="button"
        class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
        @click="showPassword = !showPassword"
      >
        <Eye v-if="!showPassword" class="w-5 h-5" />
        <EyeOff v-else class="w-5 h-5" />
      </button>
    </div>
    <span v-if="error" class="text-red-500 text-xs mt-1">{{ error }}</span>
  </div>
</template>